import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  // useTheme,
} from "@mui/material";
import {
  DeckRounded,
  LocalBarRounded,
  WineBarRounded,
  NetworkWifiRounded,
  FamilyRestroomRounded,
  BackpackRounded,
  LocalParkingRounded,
  LiquorRounded,
  SmokingRoomsRounded,
  DirectionsCarRounded,
  InfoRounded,
  FemaleRounded,
  PaidRounded,
  RestaurantRounded,
  WashRounded,
  MusicNoteRounded,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { isArray } from "lodash";

import { getAPI } from "../api/callAPI";

const iconsMap = {
  Rooftop: <DeckRounded fontSize="large" />,
  "Outside Bar": <WineBarRounded fontSize="large" />,
  "WI-FI": <NetworkWifiRounded fontSize="large" />,
  "Family friendly": <FamilyRestroomRounded fontSize="large" />,
  Cocktails: <LocalBarRounded fontSize="large" />,
  "Valet Parking": <LocalParkingRounded fontSize="large" />,
  "Takeaway available": <BackpackRounded fontSize="large" />,
  "Full bar available": <LiquorRounded fontSize="large" />,
  "Smoking area": <SmokingRoomsRounded fontSize="large" />,
  "Car Park": <DirectionsCarRounded fontSize="large" />,
  Parking: <LocalParkingRounded fontSize="large" />,
  "Free-Wifi": <NetworkWifiRounded fontSize="large" />,
  "Family-Friendly": <FamilyRestroomRounded fontSize="large" />,
  "Valet parking": <LocalParkingRounded fontSize="large" />,
  "wi-fi available and its family friendly": (
    <NetworkWifiRounded fontSize="large" />
  ),
  "WIFI only Official Use": <NetworkWifiRounded fontSize="large" />,
  "Smoking Area": <SmokingRoomsRounded fontSize="large" />,
  "Family & Coupe entry": <FamilyRestroomRounded fontSize="large" />,
  "Safe for Girls": <FemaleRounded fontSize="large" />,
  "Paid Parking as per mall": <PaidRounded fontSize="large" />,
  "WiFi and Family Friendly": <NetworkWifiRounded fontSize="large" />,
  "Valet Mall Parking": <LocalParkingRounded fontSize="large" />,
  Wifi: <NetworkWifiRounded fontSize="large" />,
  "Family Restaurant": <RestaurantRounded fontSize="large" />,
  "wi-fi": <NetworkWifiRounded fontSize="large" />,
  Friendly: <FamilyRestroomRounded fontSize="large" />,
  "Parking available": <LocalParkingRounded fontSize="large" />,
  wifi: <NetworkWifiRounded fontSize="large" />,
  "family - Friendly": <FamilyRestroomRounded fontSize="large" />,
  washroom: <WashRounded fontSize="large" />,
  "dance floor": <MusicNoteRounded fontSize="large" />,
};

export default function Facilities({ storeID }) {
  // const { palette } = useTheme();
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(null);
  const [data, setData] = useState([]);

  const { endpoint } = useSelector((state) => state.auth);

  const getFacilities = useCallback(async () => {
    if (storeID) {
      setLoading(true);
      setError(null);
      try {
        // getStoreAmenities: id => `/api/store-amenities/${id}`,
        const resp = await getAPI(endpoint, `store-amenities/${storeID}`);
        // console.log("getFacilities resp >>> ", resp);

        if (resp.success) {
          if (isArray(resp.data) && resp.data.length > 0) {
            setData(resp.data);
          }
        }
      } catch (error) {
        console.error("getFacilities error >>> ", error);
        setData([]);
        setError("No Facilities available");
      }
      setLoading(false);
    }
  }, [endpoint, storeID]);

  useEffect(() => {
    getFacilities();
  }, [getFacilities]);

  if (isLoading) {
    return (
      <Box>
        <CircularProgress variant="indeterminate" />
      </Box>
    );
  }

  if (isError || !isArray(data) || data?.length === 0) {
    return null;
  }

  return (
    <>
      <Typography
        variant="h5"
        gutterBottom
        color={"primary"}
        sx={{ fontWeight: "600" }}
        className="facilities-outer mt-4 mb-3"
      >
        Facilities
      </Typography>
      <Grid className="facilities-wrapper">
        {data.map((facility, idx) => (
          <Grid key={`facility-${idx}-${facility.amenities}`} className="facilities-internal">
            {iconsMap[facility.amenities] || <InfoRounded fontSize="large" />}
            <Typography>{facility.amenities}</Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
